export class ProfileCounters {
    sqlQueryCount = new ProfileCounter()
    sqlQueryTime = new ProfileCounter()
    sqlQueryResultRows = new ProfileCounter()
}

class ProfileCounter {
    private count: number = 0
    increment(): void {
        this.count++
    }
    add(value: number): void {
        this.count += value
    }
    get(): number {
        return this.count
    }
}